import { a as a$1 } from './chunk-DRNBRV2J.mjs';
import { a } from './chunk-T6K6XLYD.mjs';
import { jsxs, jsx } from 'react/jsx-runtime';

var u={min:1,max:100},m=t=>{let o=()=>{t.qty<t.max&&t.setQty(e=>e+1);},r=()=>{t.qty>t.min&&t.setQty(e=>e-1);};return jsxs(a,{className:t.className,children:[jsx(a$1,{variant:"secondary",onClick:r,children:"-"}),jsx("div",{className:"ui-px-4 ui-py-2 ui-text-center",children:t.qty}),jsx(a$1,{variant:"secondary",onClick:o,children:"+"})]})};m.defaultProps=u;

export { m as a };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-TZWSQGPS.mjs.map